import React from "react";
import { PAIN_POINTS } from "../../data/content";
import { XIcon } from "lucide-react";
export function Problem() {
  return <section className="bg-neutral-950 py-16 px-4 border-t border-neutral-900" data-id="element-206" data-mp="2wgetvdo7zdgl">
      <div className="max-w-4xl mx-auto" data-id="element-207" data-mp="2rnlmsj5a3t1c">
        <h2 className="font-display text-3xl sm:text-5xl text-white text-center uppercase leading-none" data-id="element-208" data-mp="2rmk9e80siugg">
          ¿Cuántas semanas más vas a seguir{" "}
          <span className="text-[#e10600]" data-id="element-209" data-mp="2hqhadb18jbxq">sin empezar?</span>
        </h2>

        <div className="mt-8 space-y-4 text-neutral-300 text-lg leading-relaxed" data-id="element-210" data-mp="2cre5bql995pr">
          <p data-id="element-211" data-mp="2cth3wz0h4763">Querés emprender con comida. Lo sabés hace tiempo.</p>
          <p data-id="element-212" data-mp="28q2nw8cjbqsn">Tenés ganas. Tenés cocina. Tenés algo para ofrecer.</p>
          <p data-id="element-213" data-mp="23r7vceormnvc">Pero cada vez que intentás arrancar, aparece lo mismo:</p>
          <p className="text-neutral-400" data-id="element-214" data-mp="6y6122kx2uik">
            No sabés exactamente qué vender. No sabés cómo calcular el precio sin trabajar
            gratis. No sabés cómo presentarlo para que parezca profesional. No sabés qué
            responder cuando un cliente te escribe por WhatsApp. No sabés cómo organizar la
            producción cuando llegan varios pedidos juntos.
          </p>
          <p data-id="element-215" data-mp="197sg6zrp797d">
            Y entonces buscás en Google. En YouTube. En grupos de Facebook. Encontrás mil cosas
            sueltas, contradictorias, pensadas para otros mercados.
          </p>
          <p className="text-white font-semibold" data-id="element-216" data-mp="10bkvtmc7dmid">Y seguís sin empezar.</p>
          <p className="font-condensed text-2xl text-[#e10600] tracking-wide" data-id="element-217" data-mp="1nzkvxcvemp9m">
            No es falta de ganas. Es falta de un sistema.
          </p>
        </div>

        <ul className="mt-10 space-y-3" data-id="element-218" data-mp="1e9rgu1w1zs0m">
          {PAIN_POINTS.map((p, i) => <li key={i} className="flex items-start gap-3 bg-black/60 border border-red-900/40 rounded-lg p-4" data-id="element-219" data-mp="1e7f1lwhojvr9" data-mpi={i}>
              <XIcon className="w-5 h-5 text-[#e10600] flex-shrink-0 mt-0.5" data-id="element-220" data-mp="26y6xstyqwkel" />
              <span className="text-neutral-300" data-id="element-221" data-mp="26w2jrj74u50l">{p}</span>
            </li>)}
        </ul>

        <p className="text-center font-display text-2xl sm:text-3xl text-white mt-10 uppercase" data-id="element-222" data-mp="2bqq9tmhsb7ha">
          ¿Y si esta fuera la última semana que pasás así?
        </p>
      </div>
    </section>;
}